import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HttpRequestService<T> {
    public url: string;
  
    constructor(
      private httpClient: HttpClient) {
        this.url = environment.production ? environment.API_URL : 'funds';
    }

protected post(endpoint: string, data: any, id?: number, httpHeaders?: HttpHeaders) {
    let endPointUrl: string = `${this.url}/v1/${endpoint}`;
    if (id && id != null && id != undefined) {
      endPointUrl = `${endPointUrl}/${id}`;
    }
    return this.httpClient.post(endPointUrl, data, { headers: httpHeaders ?? new HttpHeaders() });
  }

  protected get(endpoint: string, id?: number, stringParams?: { [key: string]: string }, httpHeaders?: HttpHeaders): Observable<any> {
    let endPointUrl: string = `${this.url}/v1/${endpoint}`;
    if (id && id != null && id != undefined) {
      endPointUrl = `${endPointUrl}/${id}`;
    }
    if (stringParams && stringParams != null && stringParams != undefined) {
      const params = new Array<string>();
      Object.keys(stringParams).forEach(key => {  
        const value = stringParams[key];
        if (value) {
          params.push(`${key}=${value}`);
        }
      });
      if (params.length > 0) {
        endPointUrl = `${endPointUrl}?${params.join('&')}`;
      }
    }
    return this.httpClient.get(endPointUrl, { headers: httpHeaders ?? new HttpHeaders() })
      .pipe(map((data: any) => data));
  }

}